import React from 'react';
import { Badge } from 'react-bootstrap';

/**
 * Small badge that names the masking provider whose algorithms the current inventory reflects.
 * Shown top-right on the masking inventory page and the Inventory Manager so it's unambiguous
 * which provider the algorithm column is for. Native C2 providers (no vendor) render under a
 * friendly label; 3rd-party providers show their vendor/display name.
 *
 * @param providers   provider list from getMaskingProviders ([{serviceId, name, vendorDisplayName, vendor, isDefault}])
 * @param serviceId   the currently selected provider serviceId (null => the default)
 * @param defaultLabel friendly label for the native C2 default (e.g. "C2 Masking")
 */
function ProviderBadge({ providers, serviceId, defaultLabel = 'C2 Masking' }) {
  const list = Array.isArray(providers) ? providers : [];
  const selected =
    (serviceId && list.find((p) => p.serviceId === serviceId)) ||
    list.find((p) => p.isDefault) ||
    list[0] ||
    null;

  const label = selected
    ? (selected.vendor ? (selected.vendorDisplayName || selected.name) : defaultLabel)
    : defaultLabel;
  const isThirdParty = !!(selected && selected.vendor);

  return (
    <Badge
      pill
      variant={isThirdParty ? 'info' : 'secondary'}
      style={{ fontSize: '0.8rem', padding: '6px 12px' }}
      data-testid='provider-badge'
    >
      Provider: {label}
    </Badge>
  );
}

export default ProviderBadge;
